module.exports = __webpack_public_path__ + "static/media/AQA.302657da.png";